import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { PaymentService } from '../services/payment.service';
import { first, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PayGuard implements CanActivate {
  constructor(private paymentService: PaymentService, private router: Router) {
  }

  public canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    let id = this.getPaymentId(next);
    return this.paymentService.basePayment$.pipe(
      first(),
      map((basePayment) => {
        if (id !== null && id !== '') {
          if (basePayment?.id) {
            if (basePayment.id === id) {
              return true;
            } else {
              return this.router.parseUrl('liabilities/pay/' + basePayment.id);
            }
          } else {
            return this.router.parseUrl('liabilities/pay');
          }
        } else {
          if (basePayment?.id) {
            return this.router.parseUrl('liabilities/pay/' + basePayment.id);
          } else {
            return true;
          }
        }
      }),
    );
  };


  public getPaymentId(next: ActivatedRouteSnapshot): string {
    return next.params.id;
  }
}
